// The manage.rapnet permissions of the back office, which the BFF checks too. Every page needs one; the
// menu shows every page, and greys out the ones the user has no permission for.

// The admin screens: Devices, Upload, Compliance, Search Logs, Source Verification, Diamonds, Accounts
// and Members.
export const ADMIN_PERMISSION = 'admin';

// Everyone who signs in to manage.rapnet: the reports (Price Reports and RAPI), which admin opens too.
export const BASIC_PERMISSION = 'basic';
export const REPORTS_PERMISSIONS = [BASIC_PERMISSION, ADMIN_PERMISSION];

// Ring Orders, the Build a Ring operations grid; admin alone does not open it. The read-only
// permission opens the grid but cannot change an order's stage.
export const RING_BUILDER_PERMISSION = 'ringBuilder';
export const RING_BUILDER_READONLY_PERMISSION = 'ringbuilder_readonly';
export const RING_ORDERS_PERMISSIONS = [RING_BUILDER_PERMISSION, RING_BUILDER_READONLY_PERMISSION];

// A user needs one of these to stay signed in to the back office; anyone else is sent back to the login.
export const SIGN_IN_PERMISSIONS = [
  BASIC_PERMISSION,
  ADMIN_PERMISSION,
  RING_BUILDER_PERMISSION,
  RING_BUILDER_READONLY_PERMISSION
];
